import { Description, EmptyState, EmptyStateAccessDeniedHeader } from '@gitbook/spine-react';

/**
 * No access to the share content dialog
 */
export function PermissionDeniedDialogContent(): React.ReactElement {
    return (
        <EmptyState>
            <EmptyStateAccessDeniedHeader />
            <Description>You don't have access to these settings.</Description>
        </EmptyState>
    );
}
